import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles, Typography } from '@material-ui/core';
import { HorizontalGrid } from '@components/HorizontalGrid';

export type SuccessMessageProps = {
    message: string
}

export function SuccessMessage ({ message }: SuccessMessageProps) {
    const cls = useStyles();

    return (
        <HorizontalGrid className={cls.root}>
            <CheckCircleIcon className={cls.icon} />
            <Typography>{ message }</Typography>
        </HorizontalGrid> 
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2)
    },

    icon: {
        color: 'green',
        marginRight: theme.spacing(1),
    }
}));